// extracted by mini-css-extract-plugin
module.exports = {"root":"AvatarInput_root__3nH-Q","editIcon":"AvatarInput_editIcon__2R90H"};